"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SoulModule = require('./SoulModule');
/**
* Manage user turn-ons
* @extends SoulModule
*/


var Turnons =
/*#__PURE__*/
function (_SoulModule) {
  _inherits(Turnons, _SoulModule);

  function Turnons() {
    _classCallCheck(this, Turnons);

    return _possibleConstructorReturn(this, _getPrototypeOf(Turnons).apply(this, arguments));
  }

  _createClass(Turnons, [{
    key: "get",

    /**
    * get turnons
    * @param {Object} params
    * Prev response hash
    * @param {string} params.hash
    * Turn-ons language
    * @param {string} params.lang
    * @example soul.turnons.get({
    *   lang: 'ru',
    * })
    */
    value: function get(params) {
      return this.api.get('temptations/', _objectSpread({}, params, {
        apiKey: this.apiKey
      }));
    }
    /**
    * get liked users turnons
    * @example soul.turnons.getLiked()
    */

  }, {
    key: "getLiked",
    value: function getLiked() {
      return this.api.get('search_likes/temptations/', {
        apiKey: this.apiKey
      });
    }
    /**
    * get blocked users turnons
    * @example soul.turnons.getBlockedUsers()
    */

  }, {
    key: "getBlockedUsers",
    value: function getBlockedUsers() {
      return this.api.get('search_blocks/temptations/', {
        apiKey: this.apiKey
      });
    }
    /**
    * set turnonId in Profile
    * @example soul.turnons.setTurnonId(5)
    */

  }, {
    key: "setTurnonId",
    value: function setTurnonId(id) {
      return this.api.post("v2_users/me/temptations/".concat(id, "/"));
    }
    /**
    * remove turnonId in Profile
    * @example soul.turnons.removeTurnonId(5)
    */

  }, {
    key: "removeTurnonId",
    value: function removeTurnonId(id) {
      return this.api["delete"]("v2_users/me/temptations/".concat(id, "/"));
    }
  }]);

  return Turnons;
}(SoulModule);

module.exports = Turnons;